import { Suspense, lazy } from "react";

const LazyResults = lazy(
  () =>
    import(
      /* webpackChunkName:"results" */ "routes/property/routes/results/ResultPage"
    )
);

const LazySoldPrice = lazy(
  () => import(/* webpackChunkName:"soldprice" */ "routes/soldprice")
);

const LazyResetPassword = lazy(
  () =>
    import(/* webpackChunkName:"resetpassword"  */ "routes/auth/resetPassword")
);
const LazySetPassword = lazy(
  () => import(/* webpackChunkName:"setpassword"  */ "routes/auth/setPassword")
);

const LazyChangedPasswordSuccess = lazy(
  () =>
    import(/* webpackChunkName:"savedPasswordSuccess"  */ "routes/auth/Success")
);

const LazyLogOut = lazy(
  () =>
    import(
      /* webpackChunkName:"logout", webpackPrefetch: true  */ "routes/auth/LogOut"
    )
);

const LazyUnauthorized = lazy(
  () =>
    import(
      /* webpackChunkName:"unauthorized", webpackPrefetch: true  */ "routes/auth/Unauthorized"
    )
);

const LazyTemporaryPassword = lazy(
  () =>
    import(
      /* webpackChunkName:"confirmPassword", webpackPrefetch: true  */ "routes/auth/temporaryPassword"
    )
);

const LazyTokenExpired = lazy(
  () =>
    import(
      /* webpackChunkName:"tokenExpired", webpackPrefetch: true  */ "routes/token-expired"
    )
);

const LazyAdminUserOverview = lazy(
  () =>
    import(
      /* webpackChunkName:"adminUserOverview"  */ "routes/back-office/user/overview/Overview"
    )
);

const LazyAdminUserManagementCreate = lazy(
  () =>
    import(
      /* webpackChunkName:"adminUserManagementCreate" */ "routes/back-office/user/update/CreateUser"
    )
);

const LazyAdminUserManagementEdit = lazy(
  () =>
    import(
      /* webpackChunkName:"adminUserManagement"  */ "routes/back-office/user/update/UpdateUser"
    )
);

const LazyReports = lazy(
  () => import(/* webpackChunkName:"reports" */ "routes/reports")
);

const LazyAlerts = lazy(
  () => import(/* webpackChunkName:"alerts" */ "routes/alerts")
);

const LazyOrder = lazy(
  () =>
    import(
      /* webpackChunkName:"order-page",  webpackPrefetch: true */ "routes/order-page/Order"
    )
);

const LazyApOrder = lazy(
  () =>
    import(
      /* webpackChunkName:"ap-order-page" */ "routes/ap-order-page/ApOrder"
    )
);

const LazyViewCampaign = lazy(
  () =>
    import(
      /* webpackChunkName:"ViewActiveCampaign" */ "routes/property/routes/view-active-campaign/ViewActiveCampaign"
    )
);

const LazyProgramSelector = lazy(
  () =>
    import(
      /* webpackChunkName:"ProgramSelector",  webpackPrefetch: true */ "routes/program-selector/ProgramSelector"
    )
);

const LazyBackofficeRoutes = lazy(
  () => import(/* webpackChunkName: "back-office" */ "routes/back-office/index")
);

const LazySellersChoice = lazy(
  () =>
    import(
      /* webpackChunkName: "sellers-choice" */ "routes/customer/sellers-choice-order-page"
    )
);

const LazyReporting = lazy(
  () => import(/* webpackChunkName: "reporting" */ "routes/customer/reporting")
);

const LazyEmail = lazy(
  () =>
    import(
      /* webpackChunkName: "email-configuration" */ "routes/customer/email"
    )
);

export function SuspenseAdminUserOverview() {
  return (
    <Suspense fallback={null}>
      <LazyAdminUserOverview />
    </Suspense>
  );
}

export function SuspenseAdminUserManagementCreate() {
  return (
    <Suspense fallback={null}>
      <LazyAdminUserManagementCreate />
    </Suspense>
  );
}

export function SuspenseAdminUserManagementEdit() {
  return (
    <Suspense fallback={null}>
      <LazyAdminUserManagementEdit />
    </Suspense>
  );
}

export function SuspenseUnauthorized() {
  return (
    <Suspense fallback={null}>
      <LazyUnauthorized />
    </Suspense>
  );
}

export function SuspenseLogOut() {
  return (
    <Suspense fallback={null}>
      <LazyLogOut />
    </Suspense>
  );
}

export function SuspenseTemporaryPassword() {
  return (
    <Suspense fallback={null}>
      <LazyTemporaryPassword />
    </Suspense>
  );
}

export function SuspenseTokenExpired() {
  return (
    <Suspense fallback={null}>
      <LazyTokenExpired />
    </Suspense>
  );
}

export function SuspenseResults() {
  return (
    <Suspense fallback={null}>
      <LazyResults />
    </Suspense>
  );
}

export function SuspenseResetPassword() {
  return (
    <Suspense fallback={null}>
      <LazyResetPassword />
    </Suspense>
  );
}
export function SuspenseSetPassword() {
  return (
    <Suspense fallback={null}>
      <LazySetPassword />
    </Suspense>
  );
}

export function SuspenseChangedPasswordSuccess() {
  return (
    <Suspense fallback={null}>
      <LazyChangedPasswordSuccess />
    </Suspense>
  );
}

export function SuspenseSoldPrice() {
  return (
    <Suspense fallback={null}>
      <LazySoldPrice />
    </Suspense>
  );
}

export function SuspenseReports() {
  return (
    <Suspense fallback={null}>
      <LazyReports />
    </Suspense>
  );
}

export function SuspenseAlerts() {
  return (
    <Suspense fallback={null}>
      <LazyAlerts />
    </Suspense>
  );
}

export function SuspenseOrder() {
  return (
    <Suspense fallback={null}>
      <LazyOrder />
    </Suspense>
  );
}

export function SuspenseApOrder() {
  return (
    <Suspense fallback={null}>
      <LazyApOrder />
    </Suspense>
  );
}

export const SuspenseViewCampaign = () => (
  <Suspense fallback={null}>
    <LazyViewCampaign />
  </Suspense>
);

export const SuspenseProgramSelector = () => (
  <Suspense fallback={null}>
    <LazyProgramSelector />
  </Suspense>
);

const LazyOrderCampaign = lazy(
  () => import(/* webpackChunkName:"Toolbox" */ "./customer/order-campaign")
);

export function SuspenseOrderCampaign() {
  return (
    <Suspense fallback={null}>
      <LazyOrderCampaign />
    </Suspense>
  );
}

export function SuspenseBackoffice() {
  return (
    <Suspense fallback={null}>
      <LazyBackofficeRoutes />
    </Suspense>
  );
}

export function SuspenseSellersChoice() {
  return (
    <Suspense fallback={null}>
      <LazySellersChoice />
    </Suspense>
  );
}

export function SuspenseReporting() {
  return (
    <Suspense fallback={null}>
      <LazyReporting />
    </Suspense>
  );
}

export function SuspenseEmail() {
  return (
    <Suspense fallback={null}>
      <LazyEmail />
    </Suspense>
  );
}
